// extracted by mini-css-extract-plugin
export var chip = "_3s-0";
export var filterDropdown = "_3s-5";
export var filterItem = "_3s-6";
export var icon = "_3s-1";
export var removeButton = "_3s-3";
export var removeIcon = "_3s-4";
export var separator = "_3s-2";